import {Tooltip} from 'antd';
import React from 'react';

function InfoIcon() {
  return (
    <svg
      className="info-icon"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M8 11V7"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <circle cx="8" cy="5" r="0.7" fill="currentColor" />
    </svg>
  );
}

/** Label row for Form.Item (no outer <label> — Form.Item provides association). */
export function FormItemLabel({
  children,
  withInfo = true,
  hint
}: {
  children: React.ReactNode;
  withInfo?: boolean;
  hint?: string;
}): JSX.Element {
  const infoIcon = hint ? (
    <Tooltip title={hint}>
      <span className="info-icon-trigger" role="img" aria-label="Field help">
        <InfoIcon />
      </span>
    </Tooltip>
  ) : (
    <InfoIcon />
  );

  return (
    <span className="goal-scope-field-label">
      <span>{children}</span>
      {withInfo && infoIcon}
    </span>
  );
}
